module.exports = __webpack_public_path__ + "static/media/hero-img.c20d0522.png";